module.exports = __webpack_public_path__ + "media/mosaics/Mosaics-WhoItsFor-Milestones-b61b5981.jpg";